export default [
  {
    name: 'vehicle-create',
    path: '/vehicles/create',
    component: () => import('@/views/vehicles/VehicleManage')
  },
  {
    name: 'vehicle-edit',
    path: '/vehicles/:id/edit',
    component: () => import('@/views/vehicles/VehicleManage')
  },
  {
    name: 'vehicle-view',
    path: '/vehicles/:id/view',
    component: () => import('@/views/vehicles/VehicleManage')
  },
  {
    name: 'vehicle-find',
    path: '/vehicles/find',
    component: () => import('@/views/vehicles/VehicleFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeVehicles.js